/**
 * Created by neo on 03.05.22.
 */
import { makeAutoObservable } from 'mobx';

export type ProgramActiveResponseJson = {
  active: boolean;
  activeSince?: string;
};

export type ProgramActiveResponse = {
  active: boolean;
  activeSince?: Date;
};

export function createProgramActiveResponse(json?: Partial<ProgramActiveResponseJson>): ProgramActiveResponse {
  return makeAutoObservable({
    active: json?.active ?? false,
    activeSince: json?.activeSince ? new Date(json.activeSince) : undefined,
  });
}
